<ion-header class="ion-no-shadow ion-no-border">
    <header-notifications></header-notifications>
    <ion-toolbar class="ion-hide-xl-up">

        <a *ngIf="plt.eventsCount > 1"
           (click)="plt.openEventMenu()"
           class="change-event">
            <svg-icon [applyClass]="true"
                      src="/assets/icons/change-event.svg">
            </svg-icon>
            <ion-badge *ngIf="plt.unreadOtherCount"
                       class="notification">
                {{ plt.unreadOtherCount }}
            </ion-badge>
        </a>
        <ion-title class="full"
                   [innerHTML]="'ASK_THE_SPEAKER_HEADER' | trns">
        </ion-title>
    </ion-toolbar>
</ion-header>

<ion-content class="ion-no-padding">
    <ion-refresher *ngIf="plt.sizeSm && segment == 'agenda'"
                   (ionRefresh)="refreshAgenda($event)"
                   slot="fixed">
        <ion-refresher-content></ion-refresher-content>
    </ion-refresher>

    <app-out-link></app-out-link>

    <div class="content-box ask-the-speaker"
         *ngIf="!loading">
        <h1 [innerHTML]="'ASK_THE_SPEAKER_HEADER' | trns"></h1>

        <ion-segment *ngIf="plt.sizeSm"
                     [(ngModel)]="segment"
                     value="dashboard">
            <ion-segment-button value="agenda"
                                (click)="tabChanged('agenda')">
                <ion-label class="ion-text-uppercase">{{ 'ASK_THE_SPEAKER_SPEAKERS_AGENDA_SEGMENT' | trns }}</ion-label>
            </ion-segment-button>
            <ion-segment-button value="questions"
                                (click)="tabChanged('questions')">
                <ion-label class="ion-text-uppercase">{{ 'ASK_THE_SPEAKER_SPEAKERS_QUESTION_SEGMENT' | trns }}</ion-label>
            </ion-segment-button>

        </ion-segment>


        <ion-grid class="ion-no-padding">
            <ion-row>
                <ion-col *ngIf="!plt.sizeSm || segment == 'agenda'"
                         [size]="!plt.sizeSm ? 6 : 12"
                         class="ion-no-padding">
                    <div class="content-box-inner">
                        <div class="content-header">
                            <ion-grid class="ion-no-padding">
                                <ion-row>
                                    <ion-col *ngIf="!plt.sizeSm"
                                             size="6"
                                             class="ion-no-padding">
                                        <h2>{{ 'ASK_THE_SPEAKER_SPEAKERS_TITLE' | trns }}</h2>
                                    </ion-col>
                                    <ion-col class="ion-no-padding ion-text-right ion-align-content-top">
                                        <ion-searchbar class="ion-no-padding ion-no-margin ion-text-left"
                                                       [placeholder]="'ASK_THE_SPEAKER_SEARCH_PLACEHOLDER' | translate"
                                                       [(ngModel)]="search"
                                                       (ionChange)="searchPresentation()">
                                        </ion-searchbar>
                                    </ion-col>
                                </ion-row>
                            </ion-grid>
                        </div>

                        <div class="content-data scrollable-presentations"
                             [ngClass]="{'with-header': segment=='agenda'}">

                            <ng-container *ngFor="let presentation of agenda">
                                <div class="presentation-box"
                                     *ngIf="presentation.visible">

                                    <ion-grid class="ion-no-padding">
                                        <ion-row>
                                            <ion-col size="12"
                                                     size-sm="7"
                                                     class="ion-no-padding">
                                                <h2>{{presentation.translate(userLang, event.default_locale).title}}</h2>
                                            </ion-col>
                                            <ion-col class="date"
                                                     size="12"
                                                     size-sm="5"
                                                     class="ion-no-padding ion-text-right">
                                                <ng-container *ngIf="presentation.starts_at">
                                                    {{ presentation.date_starts_at | datex: 'dateFormatShort' }} {{ presentation.date_starts_at | datex: 'timeFormatDefault' }}
                                                    <ng-container *ngIf="presentation.ends_at">
                                                        - {{ presentation.date_ends_at | datex: 'timeFormatDefault' }}
                                                    </ng-container>
                                                </ng-container>
                                            </ion-col>
                                        </ion-row>
                                    </ion-grid>

                                    <ng-container *ngIf="presentation.translate(userLang, event.default_locale).description">
                                        <p *ngIf="(presentation.translate(userLang, event.default_locale).description | nlAfterP | striphtml).length > descriptionLength && presentation.shorted"
                                           class="description">
                                            <span class="ion-text-justify"
                                                  [innerHtml]="(presentation.translate(userLang, event.default_locale).description | nlAfterP | striphtml | slice:0:descriptionLength | nl2br) +'... '"></span>
                                            <a (click)="presentation.shorted = false">{{ 'ASK_THE_SPEAKER_SHOW_MORE' | trns }}</a>
                                        </p>
                                        <p *ngIf="((presentation.translate(userLang, event.default_locale).description | nlAfterP | striphtml).length <= descriptionLength) || !presentation.shorted"
                                           class="description">
                                            <span class="ion-text-justify fr-view"
                                                  [innerHtml]="presentation.translate(userLang, event.default_locale).description | nlAfterP | nl2br | linkify | safe:'html'"></span>&nbsp;
                                            <a *ngIf="(presentation.translate(userLang, event.default_locale).description | nlAfterP | striphtml).length > descriptionLength"
                                               (click)="presentation.shorted = true">{{ 'ASK_THE_SPEAKER_SHOW_LESS' | trns }}</a>
                                        </p>
                                    </ng-container>

                                    <div class="speakers">
                                        <ion-grid class="ion-no-padding">
                                            <ion-row *ngFor="let speaker of presentation.speakers">
                                                <ion-col size="2"
                                                         class="ion-no-padding">
                                                    <ion-avatar (click)="showSpeakerDetail(speaker);"
                                                                [ngClass]="{'pointer': speaker.participant_id || speaker.external_link}">
                                                        <img *ngIf="speaker.image_url || speaker.participant?.picture_url"
                                                             img-avatar
                                                             [random]="speaker.id"
                                                             [src]="speaker.image_url || speaker.participant?.picture_url">
                                                        <svg-icon *ngIf="!(speaker.image_url || speaker.participant?.picture_url)"
                                                                  [applyClass]="true"
                                                                  [class]="'avatar-fill-' + speaker.id % 3 "
                                                                  src="/assets/icons/ico-avatar-empty.svg"></svg-icon>
                                                    </ion-avatar>
                                                </ion-col>
                                                <ion-col size="6"
                                                         class="ion-no-padding">
                                                    <div (click)="showSpeakerDetail(speaker);"
                                                         [ngClass]="{'pointer': speaker.participant_id || speaker.external_link}">
                                                        <h3>{{ speaker.name || speaker.participant?.getFullName() | cut: 60 }}</h3>
                                                        <p class="position">{{ speaker.position || speaker.participant?.company | cut: 100 }}</p>
                                                    </div>
                                                </ion-col>
                                                <ion-col size="4"
                                                         class="ion-no-padding ion-text-right">
                                                    <a class=""
                                                       (click)="presentSendQuestion($event, presentation, speaker)">
                                                        {{ 'ASK_THE_SPEAKER_ASK_QUESTION' | trns}}
                                                    </a>
                                                </ion-col>
                                            </ion-row>
                                        </ion-grid>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </ion-col>

                <ion-col *ngIf="!plt.sizeSm || segment == 'questions'"
                         [size]="!plt.sizeSm ? 6 : 12"
                         class="ion-no-padding">
                    <div class="content-box-inner history">
                        <ng-container *ngIf="questionList.length">
                            <div *ngIf="!plt.sizeSm"
                                 class="content-header">
                                <h2>{{ 'ASK_THE_SPEAKER_HISTORY_TITLE' | trns }}</h2>
                            </div>
                            <div class="content-data scrollable-questions"
                                 [scrollEvents]="true"
                                 (scroll)="onScroll($event)"
                                 #questionBox>
                                <ng-container *ngFor="let question of questionList">
                                    <div class="question-box">
                                        <ion-grid class="ion-no-padding">
                                            <ion-row>
                                                <ion-col size="8"
                                                         class="ion-no-padding">
                                                    <strong class="date">{{question.date_created_at | datex:'dateFormatDefault'}} - {{question.date_created_at | datex:'timeFormatDefault'}}</strong>
                                                </ion-col>
                                                <ion-col size="4"
                                                         class="ion-no-padding ion-text-right">
                                                    <span class="status status-{{question.status}}"
                                                          *ngIf="question.status == STATUS_CREATED">{{ 'ASK_THE_SPEAKER_QUESTION_STATUS_CREATED' | trns }}</span>
                                                    <span class="status status-{{question.status}}"
                                                          *ngIf="question.status == STATUS_APPROVED">{{ 'ASK_THE_SPEAKER_QUESTION_STATUS_APPROVED' | trns }}</span>
                                                    <span class="status status-{{question.status}}"
                                                          *ngIf="question.status == STATUS_DONE">{{ 'ASK_THE_SPEAKER_QUESTION_STATUS_DONE' | trns }}</span>
                                                    <span class="status status-{{question.status}}"
                                                          *ngIf="question.status == STATUS_REFUSED">{{ 'ASK_THE_SPEAKER_QUESTION_STATUS_REFUSED' | trns }}</span>
                                                </ion-col>
                                            </ion-row>
                                            <ion-row>
                                                <ion-col size="12"
                                                         class="ion-no-padding">
                                                    <p class="ion-text-justify question-text">{{question.question}}</p>
                                                </ion-col>
                                            </ion-row>
                                            <ion-row>
                                                <ion-col size="12"
                                                         class="ion-no-padding">
                                                    <p class="name"
                                                       *ngIf="question.agenda_speaker">{{question.agenda_speaker.name || question.agenda_speaker.participant?.getFullName()}} -
                                                        {{question.agenda_speaker.agenda.title}} <span class="anonym-flag"
                                                              *ngIf="question.anonymous">({{ 'ASK_THE_SPEAKER_ASKED_ANONYMOUS' | trns }})</span></p>
                                                </ion-col>
                                            </ion-row>
                                        </ion-grid>

                                        <div class="refuse-reason"
                                             *ngIf="question.status == STATUS_REFUSED && question.refuse_reason">
                                            <p>
                                                <strong>{{ 'ASK_THE_SPEAKER_UESTION_REFUSE_REASON' | trns }}:</strong> {{ question.refuse_reason }}
                                            </p>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="!questionList.length">
                            <div class="content-header"></div>
                            <div class="content-data no-questions">
                                <h2 class="ion-text-center">{{ 'ASK_THE_SPEAKER_NO_QUESTIONS' | trns }}</h2>
                            </div>
                        </ng-container>
                    </div>
                </ion-col>
            </ion-row>
        </ion-grid>
    </div>

    <ng-container *ngIf="loading">
        <div class="content-centered-column">
            <div class="content-centered-row">
                <ion-spinner></ion-spinner>
            </div>
        </div>
    </ng-container>
</ion-content>